import AuthLayout from 'layout/Auth'
import Login from 'pages/auth/login'
import Logout from 'pages/auth/logout'
import NotActiveUser from 'pages/NotActiveUser'
import SignUp from 'pages/Organization/SignUp'
import SelectSubcription from 'pages/Organization/SelectSubscription'
import PricingEmbed from 'pages/Organization/SelectSubscription/PricingEmbed'
import SignUpError from 'pages/Organization/SignUpError'
import Welcome from 'pages/Organization/Welcome'

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: 'logout',
          element: <Logout />,
          protected: false,
        },
        {
          path: 'login',
          element: <Login />,
          protected: false,
        },
        {
          path: 'not-active',
          element: <NotActiveUser />,
          protected: false,
        },
        {
          path: 'signup',
          element: <SignUp />,
          protected: false,
        },
        {
          path: 'select-subscription',
          element: <SelectSubcription />,
          protected: false,
        },
        {
          path: 'signup-error',
          element: <SignUpError />,
          protected: false,
        },
        {
          path: 'welcome',
          element: <Welcome />,
          protected: false,
        },
      ],
    },
    {
      path: 'pricing-embed',
      element: <PricingEmbed />,
      protected: false,
    },
  ],
}

export default LoginRoutes
